import { ComponentProps } from "react";

import { PlanName } from "@/apollo/types";
import { PrimaryButton } from "@/components/elements/Button";
import { ChangePlanDialog } from "@/features/billing";
import { WithRole } from "@/features/roleAccess";
import { useDisclosure } from "@/hooks/useDisclosure";
import { useMixpanel } from "@/monitoring/mixpanel";
import { RocketIcon } from "lucide-react";

export function UpgradeNowButton(
  props: ComponentProps<typeof PrimaryButton> & {
    source: string;
    planName?: PlanName;
    onDialogClose?: () => void;
  },
) {
  const { children, planName, source, onDialogClose, ...buttonProps } = props;
  const mixpanel = useMixpanel();
  const disclosure = useDisclosure();
  return (
    <>
      <WithRole action="manageBilling">
        <PrimaryButton
          icon={children ? undefined : <RocketIcon />}
          {...buttonProps}
          onClick={(e) => {
            props.onClick?.(e);
            if (e.isDefaultPrevented()) {
              return;
            }
            mixpanel.track("Upgrade Now Button Clicked", {
              source,
              planName,
            });
            disclosure.onOpen();
          }}
        >
          {children ?? "Upgrade Today"}
        </PrimaryButton>
      </WithRole>
      <ChangePlanDialog
        {...disclosure}
        onClose={() => {
          disclosure.onClose();
          onDialogClose?.();
        }}
      />
    </>
  );
}
